// 引入vue中定义的指令对应的类型定义
import { Directive } from 'vue'

// 阻止按钮重复提交(防抖) v-norepeat
export const norepeat: Directive = {
    mounted(el, binding) {
      let timer:any
      el.addEventListener('click', () => {
        if (timer) {
          clearTimeout(timer)
        }
        if (!el.disabled) {
          el.disabled = true
          timer = setTimeout(() => {
            el.disabled = false
          }, binding.value || 1000)
        }
      })
    }
  }